import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@bd/bdui-modal';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';

const modalStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: 0;
  height: auto;
  @media (min-width: 991px) {
  }
  .ContactModal_close {
    display: block;
    position: absolute;
    right: 20px;
    top: 20px;
    width: 24px;
    height: 24px;
    padding: 0;
    box-sizing: content-box;
    background-image: url('/images/i-close.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 24px 24px;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    z-index: 2;
  }
  .ContactModal_header {
    background-color: #000000;
    background-size: 25% auto;
    background-repeat: repeat-y;
    background-position: left top;
    z-index: 1;
    position: relative;
    padding: 50px 25px 15px 25px;
    @media (min-width: 991px) {
      padding: 50px;
    }
  }
  .ContactModal_oscImage {
    display: none;
    @media (min-width: 991px) {
      display: block;
      width: 122px;
      height: 122px;
      background-color: ${colors.color4};
      background-position: center center;
      background-size: cover;
      border-radius: 50%;
    }
  }
  .ContactModal_title {
    font-family: ${typography.SansSerif};
    font-size: 29px;
    line-height: 1;
    margin: 0;
    color: #FFFFFF;
    font-weight: 700;
    @media (min-width: 991px) {
      font-size: 36px;
      line-height: 40px;
    }
  }
  .ContactModal_postTitle{
    display: block;
    font-size: 18px;
    @media (min-width: 991px) {
      font-size: 24px;
    }
  }

  .ContactModal_body {
    padding: 25px 10px;
    position: relative;
    z-index: 2;
    background-color: ${colors.color1Dark};
    @media (min-width: 991px) {
      padding: 30px 15px;
    }
  }
  .ContactModal_footer {
    color: #FFFFFF;
    background-color: #000000;
    padding: 20px 30px;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 700;
    @media (min-width: 992px) {
      display: none;
    }
    a {
      background-color: ${colors.color2};
      color: #FFFFFF;
      padding: 8px 15px;
      font-weight: 800;
      font-size: 13px;
      line-height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      width: 40%;
      img {
        margin: 0 10px 0 0;
      }
    }
  }

  .invalid-feedback {
    color: red;
  }
  .Map_img{
    height: auto;
    width: 100%;
  }
`;

const modalOverlayStyles = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;
  background-color: rgba(0,0,0, 0.75);
  overflow-y: auto;
`;


class VideoModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(e) {
    let currentElem = e.target;

    while (currentElem.tagName !== 'A' && currentElem.parentNode !== document) {
      currentElem = currentElem.parentNode;
    }

    if (currentElem.nodeName !== 'A') {
      e.preventDefault();
      this.setState({
        modalIsOpen: true,
      });
    }
  }

  closeModal(e) {
    if (e) {
      e.preventDefault();
    }
    this.setState({ modalIsOpen: false });
  }

  render() {
    const { children, map, className } = this.props;
    return (
      <div className={`VideoModal_wrapper ${className}`}>
        <span role="button" tabIndex={0} onClick={this.openModal} className="VideoModal_btn">
          {children}
        </span>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Large Map"
          className={modalStyles}
          overlayClassName={modalOverlayStyles}
        >
          <button className="ContactModal_close" onClick={this.closeModal} />
          <div className="">
            {
              map &&
              <img
                className="Map_img"
                src={map}
                alt="Large Map"
              />
            }
          </div>
        </Modal>
      </div>
    );
  }
}

VideoModal.propTypes = {
  children: PropTypes.node.isRequired,
  map: PropTypes.string,
  className: PropTypes.string,
};

VideoModal.defaultProps = {
  map: null,
  className: '',
};


export default VideoModal;



// WEBPACK FOOTER //
// ./src/pages/Overview/MapModal.js